import { __awaiter, __generator } from "tslib";
import { jsonp } from '../../common/http/jsonp';
import { fetchCartSetting } from '../site-settings/fetch-cart-setting';
import { combineUrl } from './utilities/combine-url';
var milliSecondsInSecond = 1000;
var tokenSessionKey = 'dr-token';
export var fetchToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentDate, sessionObject, expirationDate, cartSetting, tokenUrl, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentDate = new Date().getTime();
                sessionObject = JSON.parse(sessionStorage.getItem(tokenSessionKey) || '{}');
                expirationDate = sessionObject.expires || -1;
                if (!(expirationDate && currentDate < expirationDate)) return [3 /*break*/, 1];
                return [2 /*return*/, new Promise(function (resolve) { resolve(sessionObject); })];
            case 1: return [4 /*yield*/, fetchCartSetting()];
            case 2:
                cartSetting = _a.sent();
                if (!cartSetting) {
                    return [2 /*return*/, Promise.resolve(null)];
                }
                tokenUrl = combineUrl(cartSetting.tokenUrl, {
                    apiKey: cartSetting.apiKey || '',
                    format: 'jsonp',
                    locale: cartSetting.marketLocale || '',
                });
                return [4 /*yield*/, jsonp(tokenUrl)];
            case 3:
                token = _a.sent();
                token.expires = new Date().getTime() + ((token.expires_in || 0) * milliSecondsInSecond);
                sessionStorage.setItem(tokenSessionKey, JSON.stringify(token));
                return [2 /*return*/, token];
        }
    });
}); };
